/*
  Outfit Ideas - interactions (simplified)
  Handles: carousel arrows, Load More

  Cards now contain product lists inline (no modal). Image is decorative,
  product links are the only interactive elements within a card.
*/

(function () {
  'use strict';

  if (window.__outfitIdeasInit) return;
  window.__outfitIdeasInit = true;

  document.addEventListener('DOMContentLoaded', init);
  let initialized = false;

  if (document.readyState !== 'loading') init();

  function init() {
    if (initialized) return;
    initialized = true;

    document.addEventListener('click', function (e) {
      // Carousel arrow
      const arrow = e.target.closest('[data-carousel-direction]');
      if (arrow) {
        const wrap = arrow.closest('.outfit-carousel-wrap');
        if (!wrap) return;
        const carousel = wrap.querySelector('.outfit-carousel');
        if (!carousel) return;
        const amount = carousel.clientWidth * 0.8;
        carousel.scrollBy({
          left: arrow.dataset.carouselDirection === 'next' ? amount : -amount,
          behavior: 'smooth'
        });
        return;
      }

      // Load More button
      const loadMore = e.target.closest('[data-outfit-load-more]');
      if (loadMore) {
        const section = loadMore.closest('[data-section-id]');
        if (!section) return;
        const perPage = parseInt(section.dataset.perPage, 10) || 30;
        const hidden = section.querySelectorAll('.outfit-card.is-hidden');
        let revealed = 0;
        for (let i = 0; i < hidden.length && revealed < perPage; i++) {
          hidden[i].classList.remove('is-hidden');
          revealed++;
        }
        // If no more hidden cards, hide the Load More wrapper
        const stillHidden = section.querySelectorAll('.outfit-card.is-hidden');
        if (stillHidden.length === 0) {
          const wrap = loadMore.parentElement;
          if (wrap) wrap.style.display = 'none';
        }
        return;
      }
    });

    // Initial Load More visibility: hide if nothing is hidden
    document.querySelectorAll('.outfit-grid-section').forEach(function (section) {
      const hidden = section.querySelectorAll('.outfit-card.is-hidden');
      if (hidden.length === 0) {
        const wrap = section.querySelector('.outfit-load-more-wrap');
        if (wrap) wrap.style.display = 'none';
      }
    });

    // PC drag-to-scroll on carousels (touch devices use native swipe)
    document.querySelectorAll('.outfit-carousel').forEach(function (carousel) {
      let isDown = false;
      let startX = 0;
      let scrollLeft = 0;
      let moved = false;

      function onMove(e) {
        if (!isDown) return;
        e.preventDefault();
        const walk = e.pageX - startX;
        if (Math.abs(walk) > 5) moved = true;
        carousel.scrollLeft = scrollLeft - walk;
      }

      function onUp() {
        if (!isDown) return;
        isDown = false;
        carousel.classList.remove('is-dragging');
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onUp);
      }

      carousel.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        isDown = true;
        moved = false;
        startX = e.pageX;
        scrollLeft = carousel.scrollLeft;
        carousel.classList.add('is-dragging');
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onUp);
      });

      // Block native image/link ghost-drag inside the carousel
      carousel.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });

      // Suppress click after a real drag, so product/CTA links don't fire
      carousel.addEventListener('click', function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      }, true);
    });
  }
})();
